module.exports = __webpack_public_path__ + "static/media/underline_sm@2x.447a6b4f.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/images/doodles/underline_sm@2x.png
 ** module id = 2120
 ** module chunks = 44
 **/